var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgFolderOpened = function SvgFolderOpened(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.46 12",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 7068"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 7067"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.566 4.166a1.24 1.24 0 0 0-1.238-1.228h-5.55l-5.549.016A1.24 1.24 0 0 0 0 4.198v.032l1.078 6.549a1.24 1.24 0 0 0 1.238 1.22h11.1a1.24 1.24 0 0 0 1.238-1.238v-.032Z",
    "data-name": "Pfad 18873"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 7070"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 7069"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.23 1.363H9.775L8.696.072a.2.2 0 0 0-.161-.073h-4.4a1.24 1.24 0 0 0-1.238 1.22l-.19 1.155h9.625a1.82 1.82 0 0 1 1.806 1.737l.737 4.474.182 1.1a1.2 1.2 0 0 0 .106-.484l1.3-6.564v-.039a1.24 1.24 0 0 0-1.233-1.235",
    "data-name": "Pfad 18874"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFolderOpened);
export default ForwardRef;